import { render } from "./DocumentUpload.vue?vue&type=template&id=21a7d455&scoped=true"
import script from "./DocumentUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&setup=true&lang=js"

import "./DocumentUpload.vue?vue&type=style&index=0&id=21a7d455&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a7d455"],['__file',"resources/js/components/whatsapp-managment/includes/types/DocumentUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21a7d455"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21a7d455', __exports__)) {
    console.log('reload')
    api.reload('21a7d455', __exports__)
  }
  
  module.hot.accept("./DocumentUpload.vue?vue&type=template&id=21a7d455&scoped=true", () => {
    console.log('re-render')
    api.rerender('21a7d455', render)
  })

}


export default __exports__